import { EventTask } from '../../model/EventTask'
import { http } from '../../utils/http'
import { AllocateEventTaskDto, SaveEventTaskDto } from './currentEventTaskSlice'

export const saveEventTaskAsync = async (
    saveEventTaskDto: SaveEventTaskDto,
    token: string
) : Promise<EventTask | null>  => {
    console.log(saveEventTaskDto)
    const result = await http<SaveEventTaskDto, EventTask>({
        method: 'post',
        path: 'EventTasks',
        accessToken: token,
        body: saveEventTaskDto
    })
    if (result.ok && result.parsedBody) {
        return result.parsedBody || null
    }
    return null
}

export const claimEventTaskAsync = async (
    allocateEventTaskDto: AllocateEventTaskDto,
    token: string
) : Promise<boolean>  => {
    const result = await http<AllocateEventTaskDto, null>({
        method: 'post',
        path: 'EventTaskAllocation',
        accessToken: token,
        body: allocateEventTaskDto
    })
    return (result.ok)
}
